export class getCategoriasCobertura {
  static categorias(idIns){
    switch (idIns){
      case 2008: //ADICLA
        const c1 = [
          {categoria: '1. Mora cero', calif: 1, diasMora: 'Al día', porcenReq: 0, porcenCobertura: 0},
          {categoria: '2. Normal', calif: 2, diasMora: '1 a 30', porcenReq: 0, porcenCobertura: 0},
          {categoria: '3. Aceptable', calif: 3, diasMora: '31 a 60', porcenReq: 100, porcenCobertura: 0},
          {categoria: '4. Potencial', calif: 4, diasMora: '61 a 90', porcenReq: 100, porcenCobertura: 0},
          {categoria: '5. Significativo', calif: 5, diasMora: '91 a 180', porcenReq: 100, porcenCobertura: 0},
          {categoria: '6. Real', calif: 6, diasMora: 'Mayor a 180', porcenReq: 100, porcenCobertura: 0},
        ]
        return c1;
      case 21: //COOPEDUC
        const c2 = [
          {categoria: '1. Mora cero', calif: 1, diasMora: '0', porcenReq: 0, porcenCobertura: 5},
          {categoria: '2. Normal', calif: 2, diasMora: '1 a 30', porcenReq: 0, porcenCobertura: 5},
          {categoria: '3. Aceptable', calif: 3, diasMora: '31 a 60', porcenReq: 0, porcenCobertura: 5},
          {categoria: '4. Potencial', calif: 4, diasMora: '61 a 90', porcenReq: 5, porcenCobertura: 5},
          {categoria: '5. Significativo', calif: 5, diasMora: '91 a 150', porcenReq: 30, porcenCobertura: 30},
          {categoria: '6. Real', calif: 6, diasMora: '151 a 240', porcenReq: 50, porcenCobertura: 50},
          {categoria: '7. Alto riesgo', calif: 7, diasMora: '241 a 360', porcenReq: 80, porcenCobertura: 80},
          {categoria: '8. Irrecuperable', calif: 8, diasMora: 'más de 360', porcenReq: 100, porcenCobertura: 100},
        ]
        return c2;
      default: return null;
    }      
  }
}
